module.exports = __webpack_public_path__ + "images/5c0b5ac109992774086471c20fa71826.png";